// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"bubblingG\">\n    <span id=\"bubblingG_1\"></span>\n    <span id=\"bubblingG_2\"></span>\n    <span id=\"bubblingG_3\"></span>\n</div>\n";
},"useData":true});
